import { render, staticRenderFns } from "./ItemTechnikai.vue?vue&type=template&id=e0a7ef1c&scoped=true&"
import script from "./ItemTechnikai.vue?vue&type=script&lang=js&"
export * from "./ItemTechnikai.vue?vue&type=script&lang=js&"
import style0 from "./ItemTechnikai.vue?vue&type=style&index=0&id=e0a7ef1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a7ef1c",
  null
  
)

export default component.exports